<template>  
    <div  class="climate-wrap bg-white ">
        <div class="card-body m-b-0 p-20px"><h4 class="card-title">{{selAgent.reportType=='TODAY'?
            $t("dashBoard.cAgtDBSearchCount.todaySearchCount"):selAgent.reportType=='THISMONTH'?
            $t("dashBoard.cAgtDBSearchCount.monthlySearchCount"):selAgent.reportType=='THISWEEK'?
            $t("dashBoard.cAgtDBSearchCount.weeklySearchCount"):$t("dashBoard.cAgtDBSearchCount.searchCount")}}
           
            
                </h4>
            <div class="d-flex align-items-center flex-row m-t-30"><h1 class="font-light"><img
                    src="@imgPath/img/svg/icons/search-icon.svg" alt="" class="h-50px"><span
                    class="pl-5px">{{totalCount}}<sup></sup></span></h1></div>
        </div>
        <div class="chart-wrap" >
            <CChartLineSimple :chartLabels="chartLabel"  :label="$t('dashBoard.cAgtDBSearchCount.searchCount')" :dataPoints="searchCountList" pointed border-color="warning"/>
        </div>

        <!-- <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{'ErrorCode: '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
      </CAlert>  -->

    </div>




</template>
<script>
import Logger from "../../../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../../../router/index";
import apib2bSysSearchCount from "./../../../../services/apib2bSysSearchCount";
import CChartLineSimple from "../../../chart/CChartLineSimple"
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME, AGENT_DB_REPORT_TYPE } from "../../../../util/constants";
import BaseConfiguration from "../../../../config/base.js";
import SERVICE_URL from "../../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue } from "../../../../util/util";

export default {
  name: COMPONENT_NAME.C_AGT_DB_SEARCH_COUNT,
components:{
    CChartLineSimple
},
  data () {
    return {
        searchCountList:[],
        totalCount: 0,
        alertValue:null,
        timeOptions:[],
        chartLabel:[]
        // searchCountRes:null,
        // searchCountList: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12]
    }
   },
   props:{
       selAgent:{
            type: Object,
            default: null
        },
    //     status:{
    //        type: String,
    //        default:null
    //    },
   },

//    computed: {
//            ...mapGetters("sSysLogin", {
//       ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
//     }),
//         },
    async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
               
                // if (this.ADMIN_SIGNIN_RES) {
                   let searchCountRes = await this.getSearchCount();
                   this.searchCountList = this.toGetSearchCountLs(searchCountRes,this.selAgent.reportType);

                // }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGT_DB_SEARCH_COUNT,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

  methods: {

      showAlert(val) {
                this.$emit("showAlert", val);
            },

      toGetSearchCountLs(pSearchCountRes,pReportType) {
          let retValue=[];
          try {
            if(BaseConfiguration.isDebug) console.log("toGetSearchCountLs");
                       let dateFormat = null;
                       let dateValues = [];
            if(pReportType==AGENT_DB_REPORT_TYPE.THISMONTH || pReportType==AGENT_DB_REPORT_TYPE.CUSTOM) {
                        dateFormat = "DD MMM";
                         }else if(pReportType==AGENT_DB_REPORT_TYPE.THISWEEK){
                             dateFormat = "ddd";
                         }else if(pReportType==AGENT_DB_REPORT_TYPE.TODAY){
                             dateFormat = "HH";
                         }

                         
            if(pSearchCountRes && pSearchCountRes) {
                for (let i = 0; i < pSearchCountRes.length; i++) {
                    dateValues.push(this.$options.filters.formatDate(new Date(pSearchCountRes[i].hour), BaseConfiguration.defaultDateTimeFormat));
                    this.totalCount+=Number(pSearchCountRes[i].searchcount);
                   retValue.push(Number(pSearchCountRes[i].searchcount)) 
                    
                }
            }
            this.chartLabel = dateValues;
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_AGT_DB_SEARCH_COUNT,
                    "error in toGetSearchCountLs",
                    err.toString(),
                    "toGetSearchCountLs",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
     }, 

       async getSearchCount() {
                if (BaseConfiguration.isDebug) console.log("getSearchCount");
                let returnValue;
                try {
                    let searchCountReq = apib2bSysSearchCount.buildRequest(this.selAgent); //constant

                    if (searchCountReq != null) {
                        let searchCountRes = await apib2bSysSearchCount.getResponse(
                            searchCountReq
                        );
                        if (VALIDATE_SUCCESS_RES(searchCountRes)) {
                            returnValue = searchCountRes.data.data;

                        } else {
                            let error = getErrorMessage(searchCountRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_AGT_,
                        "error in  getSearchCount",
                        err.toString(),
                        "getSearchCount()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
  }
}

</script>